import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';

const PUT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const saveConsentsUrl = `${api_config.bet_tracker_api}/account/consents`;

// eslint-disable-next-line import/prefer-default-export
export const putConsents = (consents) => (
  fetch(saveConsentsUrl, {
    method: 'PUT',
    headers: PUT_HEADERS,
    body: JSON.stringify(consents),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return true;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
